import dayjs, { Dayjs } from '@util/dayjs'
import { AnyObject, Flags, Maybe, Schema, addMethod, mixed } from 'yup'

const daysTestMethod = function validate(value: unknown) {
    if (!value) {
        return true
    }

    return dayjs.isDayjs(value)
}

addMethod(mixed, 'dayjs', function method(message = 'must be a Dayjs object') {
    return this.test('dayjs', message, daysTestMethod)
})

// This is sort of a copy Yup's internal `AnyPresentValue` type
type AnyPresentValue = NonNullable<unknown>

declare module 'yup' {
    interface MixedSchema<
        TType extends Maybe<AnyPresentValue> = AnyPresentValue | undefined,
        TContext = AnyObject,
        TDefault = undefined,
        TFlags extends Flags = '',
    > extends Schema<TType, TContext, TDefault, TFlags> {
        dayjs(message?: string): this
    }
}

declare module 'yup' {
    interface DateSchema {
        dayjs(message?: string): this
    }
}

/**
 * Schema that matches a Dayjs object that is no later than the given date
 *
 * @param maxDate
 */
export const dayJsMax =
    (maxDate?: Dayjs | null) =>
    (value?: Dayjs | null): boolean => {
        if (!value || !dayjs.isDayjs(value)) {
            return false
        }

        if (!maxDate || !dayjs.isDayjs(maxDate)) {
            return false
        }

        return value.isBefore(maxDate) || value.isSame(maxDate)
    }
